type Salutation = {
  value: string;
  label: string;
};

export const salutationConfig: { [locale: string]: Salutation[] } = {
  de_DE: [
    { value: 'Mr', label: 'Herr' },
    { value: 'Ms', label: 'Frau' },
    { value: 'neutral', label: 'Divers' },
  ],
  en_CA: [
    { value: 'Mr', label: 'Mr' },
    { value: 'Ms', label: 'Mrs' },
    { value: 'neutral', label: 'Neutral' },
  ],
  fr_CA: [
    { value: 'Mr', label: 'M.' },
    { value: 'Ms', label: 'Mme' },
    { value: 'neutral', label: 'Autre' },
  ],
  en_US: [
    { value: 'Mr', label: 'Mr' },
    { value: 'Ms', label: 'Mrs' },
    { value: 'neutral', label: 'Neutral' },
  ],
};
